<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>
  @if(data.disabled){
    <div>
      Are you sure you want to enable {{data.title}}? 
    </div>
  }@else {
    Are you sure you want to disable {{data.title}}? 
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close (click)="dialogRef.close(false)">No</button>
  <button mat-button cdkFocusInitial (click)="toggleUserGroup()">Yes</button>
</mat-dialog-actions>
